import React from 'react'
import PropTypes from 'prop-types'
import STRINGS from 'utils/strings'
import { formatMinutesAsDuration } from 'utils/time'
import { normalizeSchedules } from '../utils/schedulePreviewHelpers'

const SaveResumePreview = ({ instrument }) => {
  const { metadata } = instrument
  const schedules = normalizeSchedules(metadata?.schedule)
  const schedule = schedules.find(item => item?.timeout_window) || schedules[0] || {}
  const { timeout_window } = schedule
  const { draft } = timeout_window || {}
  const { value: draftValue } = draft || {}

  if (!draft) {
    return (
      <div className='save-resume-preview'>
        <p>
          <span>{STRINGS.saveResumeQuestion}</span>
        </p>
        <p>{STRINGS.saveResumeOption1}</p>
      </div>
    )
  }

  const formatted = formatMinutesAsDuration(draftValue)

  return (
    <div className='save-resume-preview'>
      <p>
        <span>{STRINGS.saveResumeQuestion}</span>
      </p>
      <p>
        {STRINGS.saveResumeOption2} {formatted}
      </p>
    </div>
  )
}

SaveResumePreview.propTypes = {
  instrument: PropTypes.shape({
    metadata: PropTypes.shape({
      schedule: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    }),
  }),
}

export default SaveResumePreview
